import { Jsonable } from 'src/types/jsonable';

export class BaseError extends Error {
  public readonly context?: Jsonable;

  constructor(
    message: string,
    { cause, context }: { cause?: Error; context?: Jsonable } = {},
  ) {
    super(message, cause ? { cause } : {});
    this.name = this.constructor.name;

    if (context) {
      this.context = context;
    }
  }
}
